import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Select, Form, DatePicker, Image, Avatar, Button, Row, Col, Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const ModalBody = ({close, handleSubmit, promoCode, update}) => {
    const [code, setCode] = useState('');
    const [percent, setPercent] = useState(0);
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    useEffect(() => {
        if(!promoCode){
            setCode("");
            setPercent(0);
            form.setFieldsValue({
                code: "",
                percent: 0
            })
            
            return;
        }

        console.log("AAA_PROMO_CODE", promoCode);
        setCode(promoCode.Code);
        setPercent(promoCode.Percent);
        form.setFieldsValue({
            code: promoCode.Code,
            percent: promoCode.Percent
        })
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            code: code,
            percent: percent
        })
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="code" label="Promo Code"
                            rules={[
                                {
                                    required: true,
                                    message: `Promo Code is required!`,
                                },
                            ]}>
                            <input
                                name="code"
                                type="name"
                                value={code}
                                placeholder="Promo Code"
                                onChange={(e) => setCode(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="percent" label="Discount Percent"
                            rules={[
                                {
                                    required: true,
                                    message: `Discount Percent is required!`,
                                },
                            ]}>
                            <input
                                name="percent"
                                type="number"
                                placeholder="Discount Percent"
                                value={percent}
                                onChange={(e) => setPercent(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{promoCode ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;